import { ActivityInput, Domain } from '../../../graphql/generated/graphql.ts';
import { FC } from 'react';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { TextInput } from '../../../components/forms/text-input.tsx';
import { SubmitButton } from '../../../components/forms/submit.button.tsx';
import * as yup from 'yup';
import { ActivityDisplay } from '../../../components/activity-planning/activity-display.tsx';

export interface SubGoalSelectionProps {
  input: Partial<ActivityInput>;
  domain: Partial<Domain>;
  onNext: (input: Partial<ActivityInput>) => void;
  flat?: boolean;
}

const subgoalValidationSchema = yup.object().shape({
  subgoal: yup.string().required('Sub Goal is required')
});

export const SubGoalSelection: FC<SubGoalSelectionProps> = ({ domain, input, onNext, flat }) => {
  return (
    <>
      {!flat && <ActivityDisplay activity={input} domain={domain} />}
      <Typography variant="h4" sx={{ my: 2 }}>
        Add a small step towards reaching your goal.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        This is a sub-goal, which is a smaller step towards fulfillment of a larger goal. Example: if you wanted to learn a new language, you could set a sub-goal to learn 10 new
        words this week.
      </Typography>
      <Card variant={flat ? 'outlined' : 'elevation'}>
        <CardContent>
          <Formik
            validationSchema={subgoalValidationSchema}
            enableReinitialize
            initialValues={{
              subgoal: input.subgoal || undefined
            }}
            onSubmit={(values) => {
              onNext({
                ...input,
                subgoal: values.subgoal
              });
            }}
          >
            <Form>
              <Stack spacing={2}>
                <Typography variant="h6">Sub Goal (Optional)</Typography>
                <TextInput fullWidth name="subgoal" />
                <SubmitButton>Set Sub Goal</SubmitButton>
              </Stack>
            </Form>
          </Formik>
        </CardContent>
      </Card>
      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => {
          onNext({
            ...input,
            subgoal: null
          });
        }}
      >
        Skip Sub Goal
      </Button>
    </>
  );
};
